import React, { useEffect, useState } from 'react';
import { Form, Space, Tooltip } from 'antd';
import styleText from '../../../../../shared/components/rbh-text/styles';
import styleTextInput from '../../../../../shared/components/rbh-textinput/styles';
import { RBHBox, RBHButton, RBHText, RBHTextInput } from '../../../../../shared/components';
import styleButton from '../../../../../shared/components/rbh-button/styles';
import catStyled from '../FormAddEdit/styles';
import { useDispatch } from 'react-redux';
import { CategoryValidator } from '@ppvrbh/merchant-core';
import { httpCreators } from '@ppvrbh/merchant-frontend-core';
import { CatService } from '../../redux/cat-service';
import { FormattedMessage } from 'react-intl';
import { useHistory } from 'react-router';
import { CAT_REQUEST_ID_LIST } from '../../redux/cat-constant';
import { catSagas } from '../../redux/cat-saga';
import { FoodCategory } from '../../../../../shared/models/food-category';
import './style.css';
import styles from './styles';

export const FormAddEdit: React.FC<Props> = (p) => {

  let cat;
  if (p.editData) {
    cat = new FoodCategory(p.editData);
  }

  const [form] = Form.useForm();
  const [formInvalid, setFormInvalid] = useState(!cat);
  const [menuCatId] = React.useState(cat ? cat.menuCategoryId : undefined);
  const dispatch = useDispatch();
  const history = useHistory();

  useEffect(() => {
    return () => {
      if (history.action === 'POP' && p.editData) {
        history.push('/main/foodcategory');
      }
    };
  }, [history]);

  const toCat = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    history.push('/main/foodcategory');
  };

  const setFieldError = (fieldName: string, errorShow: string[]) => {
    form.setFields([{
      name: fieldName,
      errors: errorShow
    }]);
    const fieldError = form.getFieldsError();
    const firstErrorField = fieldError[0];
    form.scrollToField(`${firstErrorField?.name}`, { behavior: 'smooth' });
    setFormInvalid(true);
  };

  const onFinish = (values: any) => {
    const editData = {
      menuCategoryId: Number(menuCatId),
      menuCategoryName: values.menuCategoryName,
      menuCategoryNameEN: values.menuCategoryNameEN,
    };
    if (p.editData) {
      dispatch(httpCreators.request({
        id: CAT_REQUEST_ID_LIST.PATCH_CAT,
        sagaHandler: catSagas.patchCatHandler as any,
        callbackParams: {
          onSuccessCallback: p.onSuccessCallback,
          setFieldError,
          onNotificationError: p.onNotificationError,
          editFrom: p.editData,
          editTo: editData,
        },
        service: CatService.patchCat,
        serviceParams: editData,
      }));
    } else {
      dispatch(httpCreators.request({
        id: CAT_REQUEST_ID_LIST.POST_CAT,
        sagaHandler: catSagas.postCatHandler as any,
        callbackParams: {
          onSuccessCallback: toCat,
          setFieldError,
        },
        service: CatService.postCat,
        serviceParams: values
      }));
    }
  };

  const layout = {
    labelCol: { span: 10 },
    wrapperCol: { span: 16 },
  };

  const button = {
    wrapperCol: { offset: 10, span: 16 },
  };

  const checkFormInvalid = () => {
    let invalid = false;
    const values = form.getFieldsValue();
    for (const key in values) {
      if (key === 'menuCategoryNameEN') {
        // optional field
      } else if (values[key] === undefined || values[key] === '') {
        invalid = true;
        break;
      }
    }
    if (!invalid) {
      const errors = form.getFieldsError();
      for (const field of errors) {
        if (field.errors.length > 0) {
          invalid = true;
          break;
        }
      }
    }
    setFormInvalid(invalid);
  };

  const trimFieldValue = (fieldName: string) => {
    const value = form.getFieldValue(fieldName);
    if (value) {
      form.setFieldsValue({
        [fieldName]: value.trim()
      });
      form.validateFields([fieldName]);
    }
  };

  const text = <RBHBox style={catStyled.tooltipText}>
    <RBHBox id={'id-cate-tooltip-title'}>
      <FormattedMessage id={'main.cat_tooltip_header'} />
    </RBHBox>
    <ul>
      <li id={'id-cate-tooltip-text1'}><FormattedMessage id={'main.cat_tooltip_content_1'} /></li>
      <li id={'id-cate-tooltip-text2'}><FormattedMessage id={'main.cat_tooltip_content_2'} /></li>
      <li id={'id-cate-tooltip-text3'}><FormattedMessage id={'main.cat_tooltip_content_3'} /></li>
      <li id={'id-cate-tooltip-text4'}><FormattedMessage id={'main.cat_tooltip_content_4'} /></li>
      <li id={'id-cate-tooltip-text5'}><FormattedMessage id={'main.cat_tooltip_content_5'} /></li>
    </ul>
  </RBHBox>;

  const textOptional = (id: string) => {
    return (
      <RBHBox style={{ display: 'flex' }}>
        <RBHText style={styleText.formText} text={id} />&nbsp;
        <RBHText style={styleText.textRegular14Gray} text={'main.form.text.optional'} />
      </RBHBox>
    );
  };

  return (
    <RBHBox style={catStyled.defaultContent}>
      <Form size='large' form={form} style={styleText.formText} {...layout} onFinish={onFinish} onFieldsChange={checkFormInvalid}>
        <Tooltip id='ant-tooltip-inner' trigger={'focus'} placement='bottom' title={text}>
          <Form.Item validateTrigger={['onChange', 'onBlur']} colon={false} name='menuCategoryName'
            label={<FormattedMessage id={'main.cat_category_name'} />}
            rules={[
              { required: true, message: <FormattedMessage id={'main.form.required'} /> },
              { pattern: CategoryValidator.categoryName.regexPattern, message: <FormattedMessage id={'main.form.text.valid'} /> },
              { whitespace: true, message: <FormattedMessage id={'main.form.text.valid'} /> }
            ]}
            initialValue={cat ? cat.menuCategoryName : undefined}>
            <RBHTextInput style={styleTextInput.inputDefault} id='menuCategoryName' placeholder='main.cat_category_name_placeholder'
              maxLength={CategoryValidator.categoryName.maxLength} onBlur={() => trimFieldValue('menuCategoryName')} autoComplete='off' />
          </Form.Item>
        </Tooltip>
        <Form.Item validateTrigger={['onChange', 'onBlur']} colon={false} name='menuCategoryNameEN'
          label={textOptional('main.cat_category_name_en')}
          rules={[
            { pattern: CategoryValidator.categoryNameEN.regexPattern, message: <FormattedMessage id={'main.form.text.validEN'} /> },
            { whitespace: true, message: <FormattedMessage id={'main.form.text.validEN'} /> }
          ]}
          extra={
            <RBHBox>
              <RBHText data-testid={'categoryNameEnRemark'} id={'categoryNameEnRemark'} style={styles.remark} text={'main.cat_category_remark_en'} />
            </RBHBox>
          }
          initialValue={cat ? cat.menuCategoryNameEN : undefined}>
          <RBHTextInput style={styleTextInput.inputDefault} id='menuCategoryNameEN' placeholder='main.cat_category_name_placeholder_en'
            maxLength={CategoryValidator.categoryNameEN.maxLength} onBlur={() => trimFieldValue('menuCategoryNameEN')} autoComplete='off' />
        </Form.Item>
        <Form.Item {...button}>
          <Space size={'middle'}>
            <RBHButton id='cat_button_cancel' style={styleButton.buttonFromCancelGradient} type='primary' htmlType='button'
              onClick={p.onCancel} text='main.button_cancel' />
            {!cat ?
              <RBHButton disabled={formInvalid} id='cat_button_create' style={styleButton.buttonFromConfirmGradient} type='primary'
                htmlType='submit' text='main.button_create' /> : null}
            {cat ?
              <RBHButton disabled={formInvalid} id='cat_button_save' style={styleButton.buttonModalConfirmGradient} type='primary'
                htmlType='submit' text='main.branchform.save' /> : null}
          </Space>
        </Form.Item>
      </Form>
    </RBHBox>
  );
};
type Props = {
  onCancel?: any
  editData?: any
  onSuccessCallback?: any
  onNotificationError?: any
};

